module.exports = __webpack_public_path__ + "media/supportMessage.370f1e53.mp3";